<template>
	<v-menu
		location="bottom"
	>
		<template #activator="{ props }">
			<li>
				<a
					class="px-3 py-0"
					v-bind="props"
				>
					<v-row class="py-4 ma-0">
						<v-col class="pa-0 pr-1">
							<v-img
								:src="'/images/flags/' + selectedFlag + '.svg'"
								height="20px"
								width="24px"
							/>
						</v-col>
						<v-col class="pa-0">
							{{ selectedLocale.toUpperCase() }}
						</v-col>
						<span class="caret margin-top=8px" />
					</v-row>
				</a>
			</li>
		</template>
		<template
			v-for="(_, slot) of $slots"
			#[slot]="scope"
		>
			<slot
				:name="slot"
				v-bind="scope"
			/>
		</template>
		<v-card>
			<v-card-text>
				<v-row>
					<v-col>
						<h4><translate>Language</translate>:</h4>
						<v-list
							v-model:selected="selected"
							@update:selected="postLocale"
						>
							<v-list-item
								v-for="language in languages"
								:key="language.id"
								:value="language.iso6391"
								:disabled="language.iso6391 === selectedLanguage"
								:title="language.nativeName"
							/>
						</v-list>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-menu>
</template>

<script>

import {
	axios,
} from '../../services/axios-service.js';
import displayError from 'laravel-front-library/src/utils/displayError/displayError';

export default {
	name: 'LocaleMenu',
	props: {
		selectedLocale: {
			type: String,
			required: true
		},
		selectedFlag: {
			type: String,
			required: true,
		},
	},

	data () {
		return {
			languages: [],
			selected: [this.selectedLocale,],
		};
	},

	computed: {
		selectedLanguage () {
			return this.selected[0];
		}
	},

	mounted () {
		this.getLanguageData();
	},

	methods: {
		/**
		 * Fetches the available languages
		 *
		 * @returns {void}
		 */
		getLanguageData () {
			axios.get('/api/v0/languages/available').then(({
				data
			}) => {
				this.languages = data;
			}).catch((error) => {
				displayError(this.$gettext('Something has gone wrong during data retrieval'));
				window.captureException(error);
			});
		},

		/**
		 * Set language cookie and user language if applicable
		 *
		 * @returns {void}
		 */
		postLocale () {
			axios.post('/locale', {
				'locale': this.selectedLanguage
			}).then(() => {
				window.location.reload();
			}).catch((error) => {
				displayError(this.$gettext('Something has gone wrong during data retrieval'));
				window.captureException(error);
			});
		},

	}
};
</script>

<style scoped>
.caret {
	margin-top: 8px
}
</style>
